import styled from 'styled-components';

export const CardsContainer = styled.div({
    display: 'flex',
    flexDirection: 'column',

    '&:focus': {
        outline: 'none'
    }
});
